import * as types from "../actions/actionTypes";

const initialState = {
  products: [],
  product: null,
  productsByCategory : [],
  topSellingProducts : [],
  activeProducts: [],
  allProductsByCategory : []
};

const product = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_PRODUCT_RESPONSE:
      return { ...state, products: action.payload };
    case types.GET_PRODUCT_RESPONSE:
      return { ...state, product: action.payload };

    case types.CREATE_PRODUCT:
      return { ...state, product: null };
    case types.DELETE_PRODUCT:
      return { ...state, product: null };
    case types.UPDATE_PRODUCT:
      return { ...state, product: null };
    case types.GET_TOP_SELLING_PRODUCTS_RESPONSE:
      // return {...state, products : action?.payload}
      return {...state, topSellingProducts : action?.payload}
    case types.GET_PRODUCT_BY_CATEGORY_ID_RESPONSE:
      // return {...state, products : action?.payload}
      return {...state, productsByCategory : action?.payload}
     case types.GET_ALL_PRODUCT_BY_CATEGORY_ID_RESPONSE:
      // return {...state, products : action?.payload}
      return {...state, allProductsByCategory : action?.payload}
    case types.GET_ACTIVE_PRODUCTS_RESPONSE:
      return { ...state, activeProducts: action.payload };
    default:
      return state;
  }
};

export default product;
